module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot/spot-252-3350f5293e9f9c3c97eee28c013ef4e9.jpg";